export const designDetail = {
  underground: '地下{num}层',
  ground: '{num}层',
  overview: '概览',
  collect: '立即收藏',
  cancelCollect: '取消收藏',
  total:"共{num}张",
  title:"方案详情"
};
